interface CircleCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  disabled?: boolean;
  /** Optional data-testid for the checkbox toggle input element. */
  inputTestId?: string;
}

export function CircleCheckbox({ checked, onChange, label, disabled = false, inputTestId }: CircleCheckboxProps) {
  function handleClick() {
    if (!disabled) {
      onChange(!checked);
    }
  }

  function handleKeyDown(e: React.KeyboardEvent<HTMLDivElement>) {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      if (!disabled) {
        onChange(!checked);
      }
    }
  }

  return (
    <div
      role="checkbox"
      aria-checked={checked}
      aria-label={label}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      data-testid={inputTestId ?? 'circle-checkbox'}
      data-hitzone="true"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      className="inline-flex items-center justify-center p-[12px] cursor-pointer"
      style={{ minWidth: '44px', minHeight: '44px' }}
    >
      <div
        style={{
          width: '20px',
          height: '20px',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: checked ? '#c8651a' : 'transparent',
          border: checked ? 'none' : '1px solid #3d3a35',
          transition: 'background-color 150ms ease, border-color 150ms ease',
          flexShrink: 0,
          opacity: disabled ? 0.4 : 1,
        }}
        aria-hidden="true"
      >
        {checked && (
          <svg
            width="12"
            height="9"
            viewBox="0 0 12 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M1 4L4.5 7.5L11 1"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
    </div>
  );
}
